import React, { useEffect, useState } from "react";
import * as yup from "yup";
import ContentLayout from "../../../../partials/content/ContentLayout";
import AppForm from "../../../../partials/content/Forms/AppForm";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { DateTime } from "luxon";
import { Tab, Tabs } from "react-bootstrap";
import {
  FormArraySelectField,
  FormArrayTextField2,
  FormDateField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { getProductionOrderDetail } from "../../../../services/production/productionService";
import { useFormikContext } from "formik";
import ItemsRequestList from "../../inventory/stock-management/items-reservation/itemsRequestList";
import ProductionOrderStocks from "./ProductionOrderStocks";
const productionOrderFormSchema = () => {
  return yup.object().shape({
    plantName: yup.string().required("Plant is required"),
    itemName: yup.string().required("Production Item is required"),
    prodQty: yup.number().min(1, "Production qty cannot be zero"),
    uomName: yup.string().required("Unit is required"),
    boms: yup.array().of(
      yup.object().shape({
        bomStockPlan: yup.array().of(
          yup.object().shape({
            warehouseName: yup.string("Warehouse is required"),
            qty: yup.number().min(1, "Qty is required"),
          })
        ),
      })
    ),
  });
};
function ProcessProductionOrderForm({ history, match }) {
  const { productionOrderID } = match.params;
  const [productionOrder, setProductionOrder] = useState({
    ID: 0,
    plantID: 0,
    plantName: "",
    statusID: 1,
    itemID: 0,
    varCode: "",
    itemName: "",
    prodQty: 0,
    uomID: 0,
    uomName: "",
    planStartDate: DateTime.now().startOf("day"),
    planEndDate: DateTime.now().startOf("day"),
    confirmStartDate: DateTime.now().startOf("day"),
    confirmEndDate: DateTime.now().startOf("day"),
    boms: [],
    routings: [],
    stocks: [],
  });
  const getProductionOrderData = async (productionOrderID = 0) => {
    const response = await getProductionOrderDetail(productionOrderID);
    const { data } = response.data;
    setProductionOrder(data.productionOrder);
  };
  useEffect(() => {
    getProductionOrderData(productionOrderID);
  }, [productionOrderID]);
  return (
    <ContentLayout>
      <AppForm
        initialValues={productionOrder}
        validationSchema={productionOrderFormSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {}}
      >
        <PageSubHeader
          title="Process Production Order"
          breadcrumbs={[
            { page: "/menu", title: "Menu", active: false },
            {
              page: "/production/production-order",
              title: "Production Order List",
              active: false,
            },
            {
              page: "/production/process-production-order-form",
              title: "Process Production Order Form",
              active: true,
            },
          ]}
          actionButtons={[
            {
              title: "",
              color: "label-brand",
              icon: "fas fa-backward",
              onClick: () => {
                history.push("/production/production-order");
              },
            },
          ]}
        />
        <ProcessProductionOrderFormContent
          productionOrderID={productionOrderID}
        />
      </AppForm>
    </ContentLayout>
  );
}

function ProcessProductionOrderFormContent({ productionOrderID = 0 }) {
  const { values } = useFormikContext();
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <Tabs defaultActiveKey="prodOrder" className="mb-3">
          <Tab
            eventKey="prodOrder"
            title={`Production Order ${productionOrderID}`}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <FormTextField label="Production Order ID" name="ID" readonly />
                <FormTextField label="Plant" name="plantName" readonly />
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormDateField
                      label="Plan Start Date"
                      name="planStartDate"
                      readonly
                    />
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <FormDateField
                      label="Plan End Date"
                      name="planEndDate"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <FormTextField
                  label="Production Item"
                  name="itemName"
                  readonly
                />
                <FormTextField label="Qty" name="prodQty" readonly />
                <FormTextField label="Unit" name="uomName" readonly />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <Tabs defaultActiveKey="bom" className="mb-3">
                  <Tab eventKey="bom" title="Bill of Material">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Item ID</th>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>Unit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.boms.map((bom, index) => {
                          const planOptions = [
                            {
                              value: 1,
                              label: "Item Reservation",
                            },
                          ];
                          if (bom.itemType === 4) {
                            planOptions.push({
                              value: 2,
                              label: "Create Production Order",
                            });
                          }

                          return (
                            <React.Fragment>
                              <tr key={index}>
                                <td>{bom.reqItemID}</td>
                                <td>{bom.reqItemName}</td>
                                <td>{bom.qty}</td>
                                <td>{bom.uomName}</td>
                              </tr>
                              {bom.bomStockPlan &&
                                bom.bomStockPlan.map((plan, index2) => (
                                  <tr key={index2}>
                                    <td>
                                      <FormArraySelectField
                                        label="Plan Type"
                                        arrayPropName="boms"
                                        arrayPropName2="bomStockPlan"
                                        propName="planType"
                                        index={index}
                                        index2={index2}
                                        options={planOptions}
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField2
                                        label="Warehouse"
                                        arrayPropName="boms"
                                        arrayPropName2="bomStockPlan"
                                        propName="warehouseName"
                                        index={index}
                                        index2={index2}
                                        readonly
                                      />
                                    </td>
                                    <td>
                                      <FormArrayTextField2
                                        label="Qty"
                                        arrayPropName="boms"
                                        arrayPropName2="bomStockPlan"
                                        propName="qty"
                                        index={index}
                                        index2={index2}
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </Tab>
                  <Tab eventKey="routing" title="Routing">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Step</th>
                          <th>Operation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {values.routings.map((routing, index) => (
                          <tr key={index}>
                            <td>{routing.step}</td>
                            <td>{routing.operationName}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </Tab>
          <Tab eventKey="itemsRequest" title="Items Request">
            <ItemsRequestList productionOrderID={productionOrderID} />
          </Tab>
          <Tab eventKey="stock" title={`Stocks`}>
            <ProductionOrderStocks productionOrderID={productionOrderID} />
          </Tab>
          <Tab eventKey="process" title="Process Production"></Tab>
        </Tabs>
      </div>
    </div>
  );
}
export default ProcessProductionOrderForm;
